import * as Sentry from '@sentry/react'
import type { PropsWithChildren } from 'react'

import { AuthProvider } from '@/core/auth/providers/AuthProvider'
import { PerfilamientoErrorProvider } from '@/features/perfilamiento/components/PerfilamientoErrorModal'

function AppErrorFallback() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', gap: '12px', fontFamily: 'sans-serif' }}>
      <p style={{ fontSize: '18px', color: '#1A191A' }}>Algo salió mal. Por favor recarga la página.</p>
      <button onClick={() => window.location.reload()} style={{ padding: '8px 20px', cursor: 'pointer' }}>
        Recargar
      </button>
    </div>
  )
}

export function AppProviders({ children }: PropsWithChildren) {
  return (
    <Sentry.ErrorBoundary fallback={<AppErrorFallback />} showDialog={false}>
      <AuthProvider>
        <PerfilamientoErrorProvider>{children}</PerfilamientoErrorProvider>
      </AuthProvider>
    </Sentry.ErrorBoundary>
  )
}
